module.exports = __webpack_public_path__ + "static/media/ceilings_gwp_10y_n.40c1379b.csv";